// Doplňkové menu topbaru (pruh mezi promo barem a hlavičkou) —
// `design_handoff_doplnkove_menu`, schválená varianta 1a „Ikony + jemný podklad,
// rozdělené na dvě skupiny".
//
// Nativní `ul.top-navigation-bar-menu` je admin seznam 15 informačních odkazů
// (zbytek patří do patičky) — pro kurátorovanou řadu je nepoužitelný, proto ho
// CSS skrývá a my vkládáme vlastní výběr. Idempotentní.
//
// ⚠️ Redesign 2026-09-16 RUŠÍ vycentrovanou řadu bez podkladu a bez ikon
// (rozhodnutí Tomáše 2026-07-30, `screens/01-header.md`): pruh má vlastní světlý
// podklad a hairline linky, každá položka ikonu 15 px a řada se dělí na
// OBSAHOVÉ odkazy vlevo a SERVISNÍ vpravo. Poslední položka „Sledování
// objednávky" je tmavý pill — jediný prvek s výplní, nejčastější servisní úkon
// zákazníka. Narazí-li budoucí session na centrovanou řadu ve starším dokumentu
// a bude ji chtít vrátit — nedělat, novější handoff je nadřazený.
//
// Obsah: na shopu `/o-nas/`, `/blog/` ani `/rubriky/` neexistují (404, ověřeno
// 2026-07-30) — „Blog" proto míří na rubriku Rady a tipy, stejně jako „Všechny
// články" na homepage. Zbytek jsou URL převzaté z nativního menu, takže reálně
// existují. Časté dotazy (`/caste-dotazy/`) přibyly 2026-09-15.
//
// Pořadí a texty jsou součástí návrhu (handoff §Obsah a cíle) — neměnit.

import { icon } from './icon.js';
import { FAQ } from '../locale/cs/common.js';
import { page, withPages } from './pages.js';
import L from '../locale/cs/topBarLinks.js';

// Cíle řady jsou `pages` z manifestu shopu; stránku, kterou shop nemá (SK blog,
// B2B, prodejna, stav objednávky), řada vynechá. Popisky jsou v locale/<jazyk>/topBarLinks.js.
const CONTENT_LINKS = withPages([
  { href: page('blog', 'rady-a-tipy/'), label: L.blog, icon: 'file' },
  { href: page('b2b'), label: L.b2b, icon: 'store' },
  { href: page('service'), label: L.service, icon: 'wrench' },
  { href: page('store'), label: L.store, icon: 'pin' },
]);

const SERVICE_LINKS = withPages([
  { href: page('shipping'), label: L.shipping, icon: 'truck' },
  { href: FAQ.href, label: FAQ.navLabel, icon: 'info' },
  { href: page('contact'), label: L.contact, icon: 'phone' },
  { href: page('orderStatus'), label: L.orderStatus, icon: 'package', pill: true },
]);

function isCurrent(href) {
  return window.location.pathname.replace(/\/+$/, '') + '/' === href;
}

function buildItem({ href, label, icon: name, pill }) {
  const a = document.createElement('a');
  a.href = href;
  a.className = 'bs-topbar-links__item' + (pill ? ' bs-topbar-links__item--pill' : '');
  a.appendChild(icon(name, 'bs-topbar-links__ico'));

  const text = document.createElement('span');
  text.className = 'bs-topbar-links__label';
  // ghost dvojník v tučné váze drží šířku aktivního stavu — musí sedět na prvku,
  // ke kterému patří `::after` (`attr()` čte jen vlastní atributy)
  text.setAttribute('data-label', label);
  text.textContent = label;
  a.appendChild(text);

  if (isCurrent(href)) a.setAttribute('aria-current', 'page');
  return a;
}

function buildGroup(modifier, links) {
  const group = document.createElement('span');
  group.className = 'bs-topbar-links__group bs-topbar-links__group--' + modifier;
  for (const link of links) group.appendChild(buildItem(link));
  return group;
}

export function initTopBarLinks() {
  const bar = document.querySelector('.top-navigation-bar .container');
  if (!bar || bar.querySelector('.bs-topbar-links')) return;

  const nav = document.createElement('nav');
  nav.className = 'bs-topbar-links';
  nav.setAttribute('aria-label', L.nav);
  nav.appendChild(buildGroup('content', CONTENT_LINKS));
  nav.appendChild(buildGroup('service', SERVICE_LINKS));
  bar.insertBefore(nav, bar.firstChild);
}
